import { Link } from 'react-router-dom'
import { Section, SectionHeading, CheckItem, CTABand, SplitHero, NonMedicalNote } from '../components/ui'
import { PHONE_DISPLAY, PHONE_TEL, OFFICE_ADDRESS, CANADIAN_LINE } from '../lib/constants'

const standards = [
  'Rigorous caregiver screening and interviews',
  'Current Vulnerable Sector Checks for all staff',
  'Detailed written task checklists for every visit',
  'Comprehensive shift notes sent after every visit',
  'Regular, proactive care plan reviews',
]

export default function About() {
  return (
    <>
      <SplitHero
        eyebrow="Our Story"
        title="Dedicated to helping Calgary seniors thrive"
        lede="We believe that every senior deserves to live with dignity, safety, and confidence in their own home. Our mission is to provide the non-medical support that makes that possible."
        image="/assets/about.jpg"
        imageAlt="Two people talking warmly in a bright living room"
        actions={
          <>
            <Link to="/schedule-assessment" className="btn btn-primary">Schedule an In-Home Assessment</Link>
            <a href={PHONE_TEL} className="btn btn-secondary">Call {PHONE_DISPLAY}</a>
          </>
        }
      />

      {/* Mission & Philosophy */}
      <Section tone="white">
        <div className="grid grid-2" style={{ gap: 48 }}>
          <div>
            <SectionHeading eyebrow="Our Mission" title="Helping seniors live safely and confidently at home" />
            <p style={{ margin: '24px 0 0 0', fontSize: 19, lineHeight: 1.7, color: 'var(--color-muted)' }}>
              Aging in place shouldn't mean struggling alone. At True North, we provide the extra hands and friendly presence that turn a house into a safe, sustainable home for years to come.
            </p>
          </div>
          <div>
            <SectionHeading eyebrow="Our Philosophy" title="A 'We Listen First' approach" />
            <p style={{ margin: '24px 0 0 0', fontSize: 19, lineHeight: 1.7, color: 'var(--color-muted)' }}>
              We don't arrive with a pre-set agenda. We start by listening to your history, your preferences, and your goals. Whether it's a specific way you like your tea or a preferred walking route, your routines lead the way.
            </p>
          </div>
        </div>
      </Section>

      {/* Standards checklist */}
      <Section tone="panel">
        <SectionHeading
          title="Our High Standards for Care"
          lede="Quality care isn't just about kindness; it's about reliability, transparency, and safety. We hold ourselves to the highest standards in the industry."
        />
        <div style={{ marginTop: 40, maxWidth: 768 }}>
          <div className="grid grid-2" style={{ gap: 16 }}>
            {standards.map((s) => <CheckItem key={s}>{s}</CheckItem>)}
          </div>
        </div>
      </Section>

      {/* Proudly Canadian */}
      <Section tone="white">
        <div style={{ maxWidth: 768 }}>
          <div className="card-teal">
            <h3 style={{ margin: 0, fontSize: '1.5rem', lineHeight: 1.2, color: 'var(--color-cream)' }}>{CANADIAN_LINE}</h3>
            <p style={{ margin: '16px 0 0 0', fontSize: 17, lineHeight: 1.6, color: 'oklch(0.9765 0.0098 87.47 / 90%)' }}>
              True North is rooted right here in Calgary. We aren't a giant international franchise; we are local owners who care deeply about our neighbours.
            </p>
            <div style={{ marginTop: 24, display: 'flex', flexDirection: 'column', gap: 8, fontSize: 17, color: 'var(--color-cream)' }}>
              <p style={{ margin: 0 }}><strong>Our Office:</strong> {OFFICE_ADDRESS}</p>
              <p style={{ margin: 0 }}><strong>Serving:</strong> Calgary and surrounding communities</p>
            </div>
          </div>
        </div>
      </Section>

      {/* Non-medical disclaimer */}
      <Section tone="panel-deep">
        <div style={{ maxWidth: 768, margin: '0 auto' }}>
          <NonMedicalNote />
        </div>
      </Section>

      <CTABand />
    </>
  )
}
